import { DeliveryStatisticsEffects } from './delivery-statistics.effects';
import { EmailEffects } from './email.effects';
import { SmsEffects } from './sms.effects';
import { JumpstoryStatisticsEffects } from './jumpstory-statistics.effects';

export const effects = [
  DeliveryStatisticsEffects,
  EmailEffects,
  SmsEffects,
  JumpstoryStatisticsEffects,
];
